import React, { Component } from 'react'
import './event-student-winners.scss'
import SchoolUserApi from '../../../apis/student'
import Loading from '../../common/loading/loading'
import PaginationComponent from '../../common/cw-pagination/cw-pagination-v2'
import { Constants } from '../../../constants/constants'

class EventStudentWinnersList extends Component {
  state = {
    eventStudents: [],
    meta: { totalPages: 1, page: 1 },
    isLoading: false,
    selectedPage: 1,
    eventAggregate: {}
  }
  limit = 10
  currentPage = 1
  startIndex = 1
  filter = {}
  constructor (props) {
    super(props)
  }

  componentDidMount () {
    const { selectedClass } = this.props
    const payload = {}
    if (selectedClass && selectedClass !== 'All') {
      payload.class = selectedClass
      this.setState({
        selectedClass: payload.class
      })
    }
    this.getEventAggregateByClass({}, _ => {
      this.getEventWinnersList(payload)
    })
  }

  getEventAggregateByClass = (payload = {}, callback) => {
    const { event } = this.props
    payload.eventId = event._id
    SchoolUserApi.getEventAggregateByClass(payload)
      .then(result => {
        this.setState(
          {
            eventAggregate: result
          },
          _ => {
            callback()
          }
        )
      })
      .catch(err => {
        console.log(err)
      })
  }

  getEventWinnersList = (payload = {}) => {
    const { selectedClass } = this.state
    const { fromScreen, event } = this.props
    payload.eventId = event._id
    this.setState({
      isLoading: true
    })
    if (!payload.class && selectedClass) payload.class = selectedClass
    if (!payload.page) payload.page = 1
    if (!payload.limit)
      payload.limit = fromScreen === 'assessment-chart' ? 3 : this.limit

    payload.winners = true
    this.currentPage = payload.page

    if (this.currentPage === 1) this.startIndex = 1

    SchoolUserApi.getEventWinnersList(payload)
      .then(result => {
        this.setState({
          eventStudents: result.response,
          meta: result.meta,
          isLoading: false,
          basePath: result.basePath
        })
      })
      .catch(err => {
        console.log(err)
      })
  }

  onPageSelected = (selectedPage, startIndex) => {
    this.startIndex = startIndex
    this.filter.page = selectedPage
    this.setState({ selectedPage })
    this.getEventWinnersList(this.filter)
  }

  getEventRankCategory = (rank, className) => {
    const { event } = this.props
    const { eventAggregate } = this.state
    let percentage = 0
    if (
      rank &&
      eventAggregate &&
      eventAggregate.baselineAggregate &&
      eventAggregate.baselineAggregate[className]
    ) {
      const aggregate = eventAggregate.baselineAggregate
      percentage = (rank / aggregate[className]) * 100
      percentage = Math.ceil(percentage / 10) * 10
    }
    if (
      event.winnersMeta &&
      event.winnersMeta.awards &&
      Object.keys(event.winnersMeta.awards).length > 0
    ) {
      const awards = event.winnersMeta.awards
      let rankName = ''
      Object.keys(awards).every(awardKey => {
        const awardCondition = awardKey.split('_')
        if (rank && awardCondition[0]) {
          if (!awardCondition[1] && rank === parseInt(awardCondition[0])) {
            rankName =
              awards[awardKey].displayValue === 'Winners'
                ? awards[awardKey].displayValue
                : 'Top ' + awards[awardKey].displayValue
            return false
          } else if (
            awardCondition[1] &&
            rank >= parseInt(awardCondition[0]) &&
            rank <= parseInt(awardCondition[1])
          ) {
            rankName =
              awards[awardKey].displayValue === 'Winners'
                ? awards[awardKey].displayValue
                : 'Top ' + awards[awardKey].displayValue
            return false
          } else if (/^\d+(\.\d+)?%$/.test(awardCondition[0])) {
            const percentageValue = awardCondition[0].split('%')
            if (percentage == percentageValue[0]) {
              rankName = 'Top ' + awards[awardKey].displayValue
              return false
            }
          }
        }
        return true
      })
      return rankName
    } else {
      return ''
    }
  }

  render () {
    const { eventStudents, basePath } = this.state
    const { fromScreen } = this.props
    return (
      <>
        <div
          id='table-scoll'
          className='student-winners-list table-responsive mt-5'
        >
          {this.state.isLoading && <Loading style={{ top: '100px' }}></Loading>}
          <table className='table cw-table mb-0 align-items-center student-winners'>
            <thead>
              <tr>
                <th className='text-center th-left-radius'>Rank</th>
                <th className='text-center'>Name</th>
                <th className='text-center'>Class</th>
                <th className='text-center th-right-radius'>Category</th>
                {/* <th className='text-center th-right-radius'>Price</th> */}
              </tr>
            </thead>
            <tbody className='bg-white'>
              {eventStudents.length > 0 &&
                eventStudents.map((student, index) => (
                  <tr key={index} className='mt-4'>
                    <td className='student-rank text-center'>{student.rank}</td>
                    <td className='text-center'>
                      <div className='student-name'>
                        <div className='user-image text-right pr-4'>
                          {student.image ? (
                            <img
                              alt='img'
                              src={`${basePath}${student.image}`}
                            />
                          ) : (
                            <img
                              alt='img'
                              src={Constants.ALTERNATE_STUDENT_IMAGE}
                            />
                          )}
                        </div>
                        <div className='name-text text-left'>
                          {student?.name}
                        </div>
                      </div>
                    </td>
                    <td className='text-center'>{student.class}</td>
                    <td className='text-center'>
                      {this.getEventRankCategory(student.rank, student.class)}
                    </td>
                    {/* <td className='text-center'>
                      {student.price ? student.price : ''}
                    </td> */}
                  </tr>
                ))}
              {!eventStudents.length && (
                <tr className='mt-4'>
                  <td colSpan='8' className='text-center'>
                    {' '}
                    No Records Found
                  </td>
                </tr>
              )}
            </tbody>
          </table>
          {fromScreen !== 'assessment-chart' &&
          !this.state.isLoading &&
          this.state.meta.totalPages ? (
            <div className='card-footer'>
              <PaginationComponent
                startIndex={this.startIndex}
                selectedPage={this.currentPage}
                totalPages={this.state.meta.totalPages}
                onPageSelected={this.onPageSelected.bind(this)}
              />
            </div>
          ) : (
            ''
          )}
        </div>
      </>
    )
  }
}

export default EventStudentWinnersList
